import { ArrowThinRightIcon, textLinkStyles } from "@codat/orchard-ui";
import classNames from "classnames";
import { Link } from "react-router-dom";

import Button from "components/Button";

import styles from "./SecondaryCta.module.css";

export const SecondaryCta: React.FC<
  React.ComponentProps<typeof Button> & {
    label: string;
    analyticsName: string;
    ["data-testid"]?: string;
    externalLink?: boolean;
  }
> = ({ className, label, externalLink = false, ...props }) => {
  if (props.href && !externalLink) {
    return (
      <Link
        to={props.href}
        className={classNames(textLinkStyles, styles.link, className)}
      >
        <span>{label}</span>
        <ArrowThinRightIcon className={styles.arrow} fillColor="currentColor" />
      </Link>
    );
  }
  return (
    <Button
      {...props}
      className={classNames(styles.link, className)}
      variant="tertiary"
      target="_"
    >
      <span>{label}</span>
      <ArrowThinRightIcon className={styles.arrow} fillColor="currentColor" />
    </Button>
  );
};
